import React, { useState } from 'react';
import Navbar from '../pagesections/Navbar';
import Footer from '../pagesections/Footer';
import './style.css'; // 👈 make sure this file is in the same folder
import mentorx from '../../assets/images/mentor-x.png';
import mentorxplus from '../../assets/images/mentor-x+.png';
import hire from '../../assets/images/hire.png';

const Index = () => {
  const [email, setEmail] = useState('');
  const [showPopup, setShowPopup] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim() === '') {
      alert('Please enter your email address.');
      return;
    }
    setShowPopup(true);
  };

  return (
    <div className="account-page">
      <Navbar />

      <main>
        <div className="account-container">
          <h1>Account Deletion Information</h1>

          <p>
          Users may request the deletion of all accounts associated with RisoApp India Pvt Ltd (including RisoApp, RisoHire, MentorX, and MentorX+) at any time. Once a request is submitted, the account and all associated data will be permanently deleted after a <strong>90-day grace period.</strong>:
          </p>

          <ul>
            <li>
              All your personal information, including profile data, preferences, and saved activities, will be permanently deleted from our servers.
            </li>
            <li>
              Any linked data related to counseling sessions, job applications, or AI interactions will also be erased.
            </li>
            <li>
              <strong>This action is irreversible — once deleted, your account and data cannot be recovered.</strong>
            </li>
          </ul>

          <form onSubmit={handleSubmit} className="account-form">
            <label htmlFor="email">Enter your email to confirm deletion:</label>
            <input
              type="email"
              id="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit">Delete My Account</button>

            <div className='lg-logo-cont'>
              <div className='lg-logo-cont-item'>
              <img src={mentorx} alt="logo" />
              </div>
              <div className='lg-logo-cont-item'>
              <img src={mentorxplus} alt="logo" />
              </div>
              <div className='lg-logo-cont-item'>
              <img src={hire} alt="logo" />
              </div>
            </div>
          </form>
        </div>
      </main>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h2>Account Deletion Requested</h2>
            <p>
              Your account (<strong>{email}</strong>) will be permanently deleted within
              <strong> 90 working days</strong>.
            </p>
            <button onClick={() => setShowPopup(false)}>OK</button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Index;
